"use strict";
angular.module("setSubdomainsMgrServiceModule", [])
  .factory("setSubdomainsMgrService", ['$modal', "$compile", "$timeout", function($modal, $compile, $timeout) {
    return {
      //后台提示框模块
      backConfirmModal: function(title, content, confirm, cancel) {
        return $modal.open({
          templateUrl: "./main/backstage/loginPageMangement/setSubdomainsMgr/service/backConfirmModal/backConfirmModal_tpl.html",
          windowClass: 'backSetConfirmModal',
          backdrop: false,
          controller: "backSetConfirmModalCtrl",
          resolve: {
            title: function() {
              return title;
            },
            content: function() {
              return content;
            },
            callback: function() {
              return confirm;
            },
            cancel: function() {
              return cancel;
            }
          }
        });
      }
    };

  }]).controller('backSetConfirmModalCtrl', ['$scope', "$sce", 'title', 'content', 'callback', 'cancel', function($scope, $sce, title, content, callback, cancel) {
        $scope.cancel = function() {
            if (angular.isDefined(cancel)) cancel();
            $scope.$close();
        };
        $scope.isConfirm = function() {
            callback();
            $scope.$close();
        };
        $scope.title = title;
        $scope.content = content;
    }]);
